module.exports = __webpack_public_path__ + "img/Frame-6.249c3ba2.svg";